<template>
  <div class="w-full bg-eblack-100/70 rounded-lg overflow-y-auto">
    <form
      @submit.prevent="action()"
      class="flex flex-col gap-y-4 justify-center px-4 border-gray-200 rounded-lg p-2"
    >
      <div class="flex flex-col gap-y-2">
        <label for="name" class="text-sm md:text-md">{{ $t("customer.auto.identificacion") }}</label>
        <input
          type="text"
          name="name"
          class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
          placeholder="0000000"
          v-bind:class="{
            'ring-red-400': fieldError('dni'),
          }"
          v-model="form.dni"
          :disabled="viewClicked"
        />
        <p
          class="text-xs md:text-sm text-red-400 pl-2"
          v-if="fieldError('dni')"
        >
          {{ fieldError('dni') }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="name" class="text-sm md:text-md">{{ $t("customer.auto.nombre") }}</label>
        <input
          type="text"
          name="name"
          class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
          :placeholder="$t('customer.auto.emanta')"
          v-bind:class="{
            'ring-red-400': fieldError('name'),
          }"
          v-model="form.name"
          :disabled="viewClicked"
        />
        <p
          class="text-xs md:text-sm text-red-400 pl-2"
          v-if="fieldError('name')"
        >
          {{ fieldError('name') }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="last_name" class="text-sm md:text-md">{{ $t("customer.auto.apellidos") }}</label>
        <input
          type="text"
          name="last_name"
          class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
          :placeholder="$t('customer.auto.emanta')"
          v-bind:class="{
            'ring-red-400':
              fieldError('last_name'),
          }"
          v-model="form.last_name"
          :disabled="viewClicked"
        />
        <p
          class="text-xs md:text-sm text-red-400 pl-2"
          v-if="fieldError('last_name')"
        >
          {{ fieldError('last_name') }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="email" class="text-sm md:text-md">{{ $t("customer.auto.correo") }}</label>
        <input
          type="email"
          name="email"
          class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
          placeholder="emanta@emanta.com"
          v-bind:class="{
            'ring-red-400': fieldError('email'),
          }"
          v-model="form.email"
          :disabled="viewClicked"
        />
        <p
          class="text-xs md:text-sm text-red-400 pl-2"
          v-if="fieldError('email')"
        >
          {{ fieldError('email') }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="country" class="text-sm md:text-md">{{ $t("customer.auto.pais") }}</label>
        <select
          name="country"
          class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
          v-bind:class="{
            'ring-red-400': fieldError('country'),
          }"
          v-model="form.country"
          :disabled="viewClicked"
        >
          <option value="">{{ $t("customer.auto.seleccione_el_pais") }}</option>
          <option value="CR">{{ $t("customer.auto.costa_rica") }}</option>
          <option value="MX">{{ $t("customer.auto.mexico") }}</option>
          <option value="US">{{ $t("customer.auto.estados_unidos") }}</option>
        </select>
        <p
          class="text-xs md:text-sm text-red-400 pl-2"
          v-if="fieldError('country')"
        >
          {{ fieldError('country') }}
        </p>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="preferred_language" class="text-sm md:text-md"
          >{{ $t("customer.auto.idioma_preferido") }}</label
        >
        <select
          name="preferred_language"
          class="rounded-md text-sm md:text-md right-1 focus:ring-blue-400"
          v-model="form.preferred_language"
          :disabled="viewClicked"
        >
          <option value="">{{ $t("customer.auto.sin_preferencia_automatico") }}</option>
          <option v-if="showUnknownLanguageOption" :value="form.preferred_language">
            {{ form.preferred_language }}
          </option>
          <option
            v-for="language in customerLanguageOptions"
            :key="language.value"
            :value="language.value"
          >
            {{ language.label }}
          </option>
        </select>
      </div>

      <div class="flex flex-col gap-y-2">
        <label for="whatsapp_phone" class="text-sm md:text-md"
          >{{ $t("customer.auto.telefono_de_whatsapp") }}</label
        >
        <PhoneInput
          v-model="form.whatsapp_phone"
          name="whatsapp_phone"
          :default-country="form.country || 'CR'"
          :invalid="
            Boolean(fieldError('whatsapp_phone'))
          "
          :disabled="viewClicked"
        />
        <p
          class="text-xs md:text-sm text-red-400 pl-2"
          v-if="fieldError('whatsapp_phone')"
        >
          {{ fieldError('whatsapp_phone') }}
        </p>
      </div>

      <div class="flex" v-if="!viewClicked">
        <button
          type="submit"
          class="px-4 py-1.5 rounded-lg bg-green-500 text-white"
        >
          {{ button_text }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { i18n } from "@/i18n";
import customerRequests from "@/services/admin/customer-service";
import { useToast } from "vue-toastification";
import { resolveApiErrorText } from "@/utils/api-error";
import PhoneInput from "@/components/ui/PhoneInput.vue";
import {
  customerLanguageOptions,
  normalizeLanguageInput,
} from "@/shared/language/language-preferences";

function readableFieldError(value) {
  if (typeof value === "string") return value;
  if (value && Array.isArray(value.constraints) && value.constraints.length) {
    return value.constraints[0];
  }
  return value?.message || "";
}

export default {
  props: [
    "customer",
    "closeModal",
    "initData",
    "viewClicked",
    "overlayService",
  ],
  name: "FormTab",
  components: {
    PhoneInput,
  },
  data() {
    return {
      button_text: "Guardar",
      form: {
        dni: "",
        name: "",
        last_name: "",
        email: "",
        country: "",
        preferred_language: "",
        whatsapp_phone: "",
      },
      customerLanguageOptions,
      errors: [],
      id: 1,
      toast: useToast(),
    };
  },
  watch: {
    customer: {
      handler(value) {
        if (value) {
          this.id = value.id;
          this.form.dni = value.dni;
          this.form.name = value.name;
          this.form.last_name = value.last_name;
          this.form.email = value.email;
          this.form.country = value.country;
          this.form.preferred_language = value.preferred_language || "";
          this.form.whatsapp_phone = value.whatsapp_phone;
          this.button_text = "Actualizar";
        } else {
          this.resetForm();
        }
      },
      immediate: true,
    },
  },
  computed: {
    showUnknownLanguageOption() {
      return (
        this.form.preferred_language &&
        !this.customerLanguageOptions.some(
          (language) => language.value === this.form.preferred_language
        )
      );
    },
  },
  methods: {
    action() {
      this.form.preferred_language =
        normalizeLanguageInput(this.form.preferred_language) || "";
      if (this.id == 0) {
        this.save();
      } else {
        this.update();
      }
    },
    save() {
      customerRequests
        .save(this.form)
        .then((res) => {
          if (res.status == 201) {
            this.resetForm();
            this.initData();
            if (this.overlayService) {
              this.overlayService.closeTop(true);
            } else {
              this.closeModal();
            }
            this.toast.success(i18n.global.t("customer.auto.cliente_guardado_correctamente"), {
              timeout: 3000,
              position: "top-right",
            });
          }
        })
        .catch((error) => this.handleRequestError(error));
    },
    update() {
      customerRequests
        .update(this.id, this.form)
        .then((res) => {
          if (res.status == 200) {
            this.resetForm();
            this.initData();
            if (this.overlayService) {
              this.overlayService.closeTop(true);
            } else {
              this.closeModal();
            }
            this.toast.success(i18n.global.t("customer.auto.cliente_actualizado_correctamente"), {
              timeout: 3000,
              position: "top-right",
            });
          }
        })
        .catch((error) => this.handleRequestError(error));
    },
    fieldError(field) {
      if (!Array.isArray(this.errors)) return "";
      const entry = this.errors.find((e) => e && e[field]);
      return entry ? readableFieldError(entry[field]) : "";
    },
    handleRequestError(error) {
      const response = error.response;
      if (!response) return;
      if (response.status === 409) {
        // The conflict may come from the email or the DNI unique constraint,
        // so it is surfaced as a toast instead of under a single field.
        const translate = (key, variables) => i18n.global.t(key, variables);
        this.errors = [];
        this.toast.error(
          resolveApiErrorText(
            error,
            translate,
            translate("errors.customer.already_exists")
          ),
          { timeout: 5000, position: "top-right" }
        );
        return;
      }
      this.errors = response.data?.message;
    },
    resetForm() {
      this.id = 0;
      this.form = {
        dni: "",
        name: "",
        last_name: "",
        email: "",
        country: "",
        preferred_language: "",
        whatsapp_phone: "",
      };
      this.button_text = "Guardar";
    },
  },
};
</script>

<style lang="scss" scoped></style>
